/*
This is actually it's the BOM for UTF-16, but apparently there is some magic
that makes this also work for UTF-8....
 */
const UTFBOM = "\uFEFF";

/**
 * Helper to generate a UTF-16 encoded file
 * @param csvData Array CSV data
 * @param filename String Optional file name (defaults to data.csv)
 */
export function downloadBlobAsCSV(csvData, filename) {
    if(!filename) {
        filename = "data.csv";
    }
    const blob = new Blob([UTFBOM,csvData], {type: 'text/csv;charset=utf-8;'});

    // For IE
    if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, filename);
    } else {
        const tempLink = document.createElement('a');
        tempLink.href = window.URL.createObjectURL(blob);
        tempLink.download = filename;
        tempLink.style.display = "none";
        document.body.appendChild(tempLink);
        tempLink.click();
        window.URL.revokeObjectURL(csvData);
        document.body.removeChild(tempLink);
    }
}